var map = {
	"./de": 1756,
	"./de.json": 1756,
	"./en": 1757,
	"./en.json": 1757,
	"./es": 1758,
	"./es.json": 1758,
	"./fr": 1759,
	"./fr.json": 1759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1755;